import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationHideLoading implements IntegrationMessage {

    public classId: number = IntegrationClassId.HIDE_LOADING;

}
